import TrackPayments from "../components/TrackPayments/TrackPayments";

const TrackPaymentsPage = () => {
  return <TrackPayments />;
};

export default TrackPaymentsPage;
